import Api, { apiAction } from '../api'
import { ActionTypes } from '../constants'
import { User } from '../models/users'

function updateProfileRequest(response) {
  return { type: ActionTypes.UPDATE_PROFILE_REQUEST }
}

function updateProfileError(error) {
  return {
    type: ActionTypes.UPDATE_PROFILE_FAILURE,
    error: error
  }
}

function updateProfileSuccess(response) {
  return {
    type: ActionTypes.UPDATE_PROFILE_SUCCESS,
    user: new User(response.data)
  }
}

export const updateParentProfile = ({ name, surname, middleName, phone }) => {
  const payload = { name, surname, phone, middle_name: middleName }
  return apiAction({
    requestor: () => Api.parents.profile.patch({ id: null }, payload),
    onBeforeSend: updateProfileRequest,
    onSuccess: (response) => updateProfileSuccess(response),
    onFailure: (error) => updateProfileError(error)
  })
}

export function updateTeacherProfile({ name, surname, middleName, phone }) {
  const payload = { name, surname, phone, middle_name: middleName }
  return apiAction({
    requestor: () => Api.teachers.profile.patch({ id: null }, payload),
    onBeforeSend: updateProfileRequest,
    onSuccess: (response) => updateProfileSuccess(response),
    onFailure: (error) => updateProfileError(error)
  })
}
